import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import ModalManager from '../../features/modals/ModalManagerContainer';
import Auth from '../../features/auth';
import FeatureRoute from './FeatureRoute';
import ShowLoader from './ShowLoader';
import KYC from '../../features/KYC';

class App extends Component {
  constructor(props) {
    super(props);
    //to take out from app using browser history
    props.history.listen((location, action) => {
      if (location.pathname === '/accounts/login' && props.history.action === 'POP') {
        window.history.go(-3);
      }
    });
  }
  render() {
    return (
      <div>
        <ShowLoader />
        <ModalManager />
        <KYC />
        <Switch>
          <Route exact path="/" render={() => (<Redirect to="/accounts/dashboard" />)} />
          <Route exact path="/accounts/" render={() => (<Redirect to="/accounts/dashboard" />)} />
          <Route exact path="/accounts/login" component={Auth} />
          <Route path="/(.+)" render={() => <FeatureRoute />} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(App);
